import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

// This controller is used to trigger a CSV export, either with the current selection (filters) or with the checked domains
export default class extends Controller {
  static get values() {
    return {
      url: String,
      maximum: Number,
      total: Number,
      selectedDomainIds: { type: Array, default: [] },
    }
  }

  static get targets() {
    return ["modal", "exportButton"]
  }

  // This action triggers an export if there are less than 1000 domains in the filters or if there are domains checked.
  export() {
    if (this.totalValue > this.maximumValue && this.selectedDomainIdsValue.length === 0) {
      this.exportButtonTarget.innerText = i18n.t("js.back.discover.export_button", {
        count: i18n.numberToDelimited(this.maximumValue),
      })

      new bootstrap.Modal(this.modalTarget).show()
      return
    }

    this.confirmExport()
  }

  // This action triggers an export directly.
  confirmExport() {
    TempFormHelper.create(this.urlValue, "post", (form) => {
      if (this.selectedDomainIdsValue.length > 0) {
        this.selectedDomainIdsValue.forEach((domainId) => {
          TempFormHelper.addHiddenInput(form, "id[]", domainId)
        })
      }
    }).submit()
  }

  // This action is used to update the selected leads value.
  // We trigger this using the check-all controller.
  updateSelection(event) {
    if (event.detail.dataSets) {
      this.selectedDomainIdsValue = event.detail.dataSets.map((dataSet) => dataSet.domainId).filter(Boolean)
    } else {
      this.selectedDomainIdsValue = []
    }
  }
}
